import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDesignElementBb4 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#9E5FBB"
            d="M12 6c6.627 0 12 5.373 12 12h-8.492a3.508 3.508 0 0 0-7.016 0H0C0 11.373 5.373 6 12 6"
        />
        <path
            fill="#3F81DD"
            d="M12 8.954A9.046 9.046 0 0 1 21.046 18h-5.538a3.508 3.508 0 0 0-7.016 0H2.954A9.046 9.046 0 0 1 12 8.954"
        />
        <path
            fill="#9CD2C9"
            d="M12.001 11.54A6.46 6.46 0 0 1 18.461 18H5.54a6.46 6.46 0 0 1 6.462-6.462M12 14.491A3.51 3.51 0 0 0 8.492 18h7.016A3.51 3.51 0 0 0 12 14.492"
        />
    </svg>
);
export default SvgDesignElementBb4;
